import axios from 'axios'
import qs from 'qs'

const config = {
    headers: { Pragma: 'no-cache' }
}

//  Istanza di axios
const _axios = axios.create({
    baseURL: process.env.VUE_APP_BASE_URI,
    ...config
})

//  Helper per il download di file
const downloadFile = function (relativePath, fileName, openInNewPage = false) {
    return _axios.get(relativePath, {
        responseType: 'blob'
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = fileName
        if (openInNewPage) link.target = '_blank'
        link.dispatchEvent(new MouseEvent('click'))
    })
}

const previewFile = function (relativePath) {
  return _axios.get(relativePath, {
    responseType: 'blob'
  }).then(response => {
    console.log(response);
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
    return url // restituisce l'URL blob
  })
}

//  ENDPOINTS
export default {
    instance: {
        setTokenHeader (token) {
            _axios.defaults.headers.common.Authorization = token
        },
        setResponseInterceptor (onFullfilled, onRejected) {
            _axios.interceptors.response.use(onFullfilled, onRejected)
        }
    },

    //  AUTENTICAZIONE
    auth: {
        login: (username, password) => _axios.post(`auth/azienda/`, qs.stringify({ username, password })),
        logout: async () => ({}),
        cambioCentro: (username, schema) => _axios.post(`auth/azienda/?cambio_centro&schema=${schema}`, qs.stringify({ username }))
    },

    //  AZIENDA
    azienda: {
        get: () => _axios.get(`azienda/`),
        getReportsMap: () => _axios.get(`azienda/?stats_map`),
        update: (formData) => _axios.post(`azienda/`, formData),
        getLogoUrl: () => `${process.env.VUE_APP_BASE_URI}azienda/?logo&t=${_axios.defaults.headers.common.Authorization}`,
        getFirmaTitolareUrl: () => `${process.env.VUE_APP_BASE_URI}azienda/?firma&t=${_axios.defaults.headers.common.Authorization}`,
        getTimbroUrl: () => `${process.env.VUE_APP_BASE_URI}azienda/?timbro&t=${_axios.defaults.headers.common.Authorization}`
    },

    //  PRENOTAZIONI
    prenotazioni: {
        //  filters possono essere: to, from, agricoltore, n, p
        get: (filters) => _axios.get(`prenotazioni/`, { params: filters }),
        create: (data) => _axios.post(`prenotazioni/`, qs.stringify(data)),
        update: (id, data) => _axios.post(`prenotazioni/${id}/`, qs.stringify(data)),
        forceCreate: (data) => _axios.post(`prenotazioni/?confermo_inserimento`, qs.stringify(data)),
        forceUpdate: (id, data) => _axios.post(`prenotazioni/${id}/?confermo_inserimento`, qs.stringify(data)),
        delete: (id) => _axios.delete(`prenotazioni/${id}/`)
    },

    //  AGRICOLTORI
    agricoltori: {
        getAll: () => _axios.get(`agricoltori/?all`),
        getPartial: () => _axios.get(`agricoltori/?partial`),
        getDeleted: () => _axios.get(`agricoltori/?deleted`),
        create: (data) => _axios.post(`agricoltori/`, qs.stringify(data)),
        update: (id, data, refactorConvenzione) => _axios.post(`agricoltori/${id}/?refactor=${refactorConvenzione}`, qs.stringify({
            ...data,
            note: JSON.stringify(data.note)
        })),
        restore: (id) => _axios.post(`agricoltori/?restore`, qs.stringify({ id: id })),
        delete: (id) => _axios.delete(`agricoltori/${id}/`)
    },

    //  CLIENTI
    clienti: {
        getAll: () => _axios.get(`agricoltori/?public`),
        getFromCuaa: (cuaa) => _axios.get(`agricoltori/?public&cuaa=${cuaa}`)
    },

    //  TECNICI
    tecnici: {
        getAll: () => _axios.get(`tecnici/?all`),
        getPartial: () => _axios.get(`tecnici/?partial`),
        getDeleted: () => _axios.get(`tecnici/?deleted`),
        create: (formData) => _axios.post(`tecnici/`, formData),
        update: (id, formData) => _axios.post(`tecnici/${id}/?update`, formData),
        restore: (username) => _axios.post(`tecnici/?restore`, qs.stringify({ username: username })),
        delete: (id) => _axios.delete(`tecnici/${id}/`),
        getFirmaUrl: (id) => id <= 0 ? null : `${process.env.VUE_APP_BASE_URI}tecnici/${id}/?firma&t=${_axios.defaults.headers.common.Authorization}`,
        resetProductKey: (username) => _axios.post(`tecnici/?resetpk`, qs.stringify({ username: username })),
        resetPassword: (token, password, confirm) => axios.post(`${process.env.VUE_APP_BASE_URI}tecnici/?t=${token}`, qs.stringify({
            password, confirm
        }))
    },

    manager: {
        getCentri: (username) => _axios.get(`manager/?centri_prova&username=${username}`)
    },

    //  CONVENZIONI
    convenzioni: {
        getAll: () => _axios.get(`convenzioni/?all`),
        getPartial: () => _axios.get(`convenzioni/?partial`),
        getDeleted: () => _axios.get(`convenzioni/?deleted`),
        create: (data) => _axios.post(`convenzioni/`, qs.stringify(data)),
        update: (id, data) => _axios.post(`convenzioni/${id}/`, qs.stringify(data)),
        restore: (nome) => _axios.post(`convenzioni/?restore`, qs.stringify({ nome: nome })),
        delete: (id) => _axios.delete(`convenzioni/${id}/`)
    },

    //MACCHINE
    macchine: {
        getAll: () => _axios.get('macchine/?all'),
        getForCliente: (id_agricoltore) => _axios.get(`macchine/?public&id_agricoltore=${id_agricoltore}`),
        getForAgricoltore: (id_agricoltore) => _axios.get(`macchine/?id_agricoltore=${id_agricoltore}`),
        create: (data) => _axios.post(`macchine/`, qs.stringify(data)),
        createLocal: (data) => _axios.post(`macchine/?local`, qs.stringify(data))
    },

    //  UNITA MOBILI
    unitaMobili: {
        get: (targa) => _axios.get(`unita_mobili/${targa}/`),
        getAll: () => _axios.get(`unita_mobili/?all`),
        getPartial: () => _axios.get(`unita_mobili/?partial`),
        getDeleted: () => _axios.get(`unita_mobili/?deleted`),
        create: (formData) => _axios.post(`unita_mobili/`, formData),
        update: (targa, formData) => {
            formData.append('update', null) //  Necessario parametro per update
            return _axios.post(`unita_mobili/${targa}/`, formData)
        },
        caricaProdotti: (targa, prodotti) => _axios.post(`unita_mobili/${targa}/?upload`, qs.stringify({ prodotti: JSON.stringify(prodotti) })),
        scaricaProdotto: (targa, prodotto) => _axios.post(`unita_mobili/${targa}/?download`, qs.stringify({
            sku: prodotto.sku,
            produttore: prodotto.produttore
        })),
        editQuantitaProdotto: (targa, prodotto, quantita) => _axios.post(`unita_mobili/${targa}/?scala`, qs.stringify({
            sku: prodotto.sku,
            produttore: prodotto.produttore,
            quantita: quantita
        })),
        restore: (targa) => _axios.post(`unita_mobili/${targa}/?restore`),
        delete: (targa) => _axios.delete(`unita_mobili/${targa}/`),
        getImgUrl: (targa) => !targa ? null : `${process.env.VUE_APP_BASE_URI}unita_mobili/${targa}/?img&t=${_axios.defaults.headers.common.Authorization}`
    },

    //  AVVISI
    avvisi: {
        get: (from, to) => _axios.get(`avvisi/?from=${from}&to=${to}`),
        create: (data) => _axios.post(`avvisi/`, qs.stringify(data)),
        update: (id, data) => _axios.post(`avvisi/${id}/`, qs.stringify(data)),
        delete: (id) => _axios.delete(`avvisi/${id}/`)
    },

    //  MAGAZZINO INTERNO
    magazzino: {
        getInternalAll: () => _axios.get(`magazzino/?all`),
        getInternalDismessi: () => _axios.get(`magazzino/?deleted`),
        restoreDismesso: (prodotto) => _axios.post(`magazzino/?restore&sku=${prodotto.sku}&produttore=${prodotto.produttore}`),
        dismettiFromLocal: (prodotto) => _axios.delete(`magazzino/?sku=${prodotto.sku}&produttore=${prodotto.produttore}`),
        editQuantitaPrezzo: (prodotto, quantita, price) => _axios.post(`magazzino/?scala&sku=${prodotto.sku}&produttore=${prodotto.produttore}`, qs.stringify({
            quantita, price_costumer: price
        })),
        getCategories: () => _axios.get(`magazzino/?categories`),
        addToLocal: (prodotti) => _axios.post(`magazzino/?add_to_local`, qs.stringify({ data: JSON.stringify(prodotti) })),
        getExternalByCategory: (category) => {
            axios.defaults.headers = {}
            return axios.get(process.env.VUE_APP_FG_SHOP_WS + `?order_nome&category=${category}`)
        }
    },

    //  STATISTICHE
    statistiche: {
        get: () => _axios.get(`statistiche/?all`)
    },

    //  REPORTS
    reports: {
        //  filters possono essere: id_tecnico, from, to
        get: (filters) => _axios.get(`reports/`, { params: filters }),
        getTrimestrali: () => _axios.get(`reports/?trimestrali&schema=null`),
        getFromConvenzione: (id_convenzione) => _axios.get(`reports/?schema=null&id_convenzione=${id_convenzione}`),
        getScadenza: (filters) => _axios.get((`reports/?scadenza`), { params: filters }),
        previewPDF: (numero, anno, data, telaio, cuaa) => previewFile(`reports/${numero}/${anno}/?pdf&inline&data=${data}&telaio=${telaio}&cuaa=${cuaa}`),
        downloadPDF: (numero, anno, data, telaio, cuaa) => downloadFile(`reports/${numero}/${anno}/?pdf&data=${data}&telaio=${telaio}&cuaa=${cuaa}`, `${data}-${telaio}-${cuaa}.pdf`, true),
        downloadAttachments: (numero, anno) => downloadFile(`reports/${numero}/${anno}/?attach`, `${numero}_${anno}_attachments.zip`, true),
        downloadDatiMinimiCSV: (from, to) => downloadFile(`reports/?csv&from=${from}&to=${to}`, 'trasmissione_dati_minimi_trimestrale.csv'),
        downloadDatiMinimiExcel: (from, to) => downloadFile(`reports/?excel&from=${from}&to=${to}`, 'trasmissione_dati_minimi_trimestrale.xls'),
        downloadExistentDatiMinimiExcel: (from, to) => downloadFile(`reports/?excel&exist&from=${from}&to=${to}`, 'trasmissione_dati_minimi_trimestrale.xls'),
        cancelDatiMinimiExcel: (from, to) => _axios.get(`reports/?excel&from=${from}&to=${to}&cancel`),
        setRinnovato: (id, data) => _axios.post(`reports/${id}/`, qs.stringify(data)),
        setFatturato: (id, data) => _axios.post(`reports/${id}/`, qs.stringify(data)),
        sendMail: (numero, anno, data, telaio, cuaa) => _axios.post(`reports/${numero}/${anno}/?sendmail&data=${data}&telaio=${telaio}&cuaa=${cuaa}`),
        sendMailTrimestrali: (from, to) => _axios.post(`reports/?sendmail_trimestrale&from=${from}&to=${to}`),
    },

    //  INDIRIZZI
    indirizzo: {
        getPaesi: () => _axios.get(`indirizzi/paesi/`),
        getRegioni: (paese) => _axios.get(`indirizzi/regioni/${paese}`),
        getProvince: (regione) => _axios.get(`indirizzi/province/${regione}`),
        getComuni: (provincia) => _axios.get(`indirizzi/comuni/${provincia}`),
        getByAgricoltore: (idAgricoltore) => _axios.get(`indirizzi/agricoltori/${idAgricoltore}`),
        getByConvenzioneOfAgricoltore: (idAgricoltore) => _axios.get(`indirizzi/?addresses&convenzione&agricoltore=${idAgricoltore}`),
        resolveGmapAddress: (address) => {
            axios.defaults.headers = {}
            return axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
                params: { address, key: process.env.VUE_APP_MAPS_KEY }
            })
        }
    },

    //  VERSIONI DISPONIBILI (da rimuovere)
    versioni: {
        get: () => _axios.get(`versioni/`)
    }

}
